module.exports = __webpack_public_path__ + "img/engraving.852485a.webp";